<template>
  <div class="admin-list" ref="main">
    <div class="main">
      <template v-if="voiceRoomDetail">
        <el-card class="detail-box">
          <div slot="header" class="clearfix">
            <span>廳詳情</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="editVoiceRoom()"
              >修改</el-button
            >
          </div>
          <div v-if="voiceRoomDetail && voiceRoomDetail.roomUid">
            <div class="item">
              <span class="label">廳封麵</span>
              <div class="value">
                <el-image
                  fit="cover"
                  style="width: 100px; height: 100px;margin-bottom:10px "
                  :preview-src-list="[voiceRoomDetail.coverImgUrl]"
                  :src="voiceRoomDetail.coverImgUrl"
                >
                </el-image>
              </div>
            </div>
            <div class="item">
              <span class="label">廳背景</span>
              <div class="value">
                <el-image
                  fit="cover"
                  style="width: 100px; height: 100px;margin-bottom:10px "
                  :src="voiceRoomDetail.backImgUrl"
                  :preview-src-list="[voiceRoomDetail.coverImgUrl]"
                >
                </el-image>
              </div>
            </div>
            <div class="item">
              <span class="label">廳ID</span>
              <span class="value">
                {{ voiceRoomDetail.roomUid }}
              </span>
            </div>
            <div class="item">
              <span class="label">廳名</span>
              <span class="value">{{ voiceRoomDetail.name }}</span>
            </div>
            <div class="item">
              <span class="label">廳主UID</span>
              <span class="value">{{ voiceRoomDetail.createBy }}</span>
            </div>
            <div class="item">
              <span class="label">廳狀態</span>
              <span class="value">{{
                voiceRoomDetail.recommend == 1 ? '在線' : '隱藏'
              }}</span>
            </div>
            <div class="item">
              <span class="label">廳公告</span>
              <p class="value">
                {{ voiceRoomDetail.desc }}
              </p>
            </div>
            <div class="item">
              <span class="label">允許上麥</span>
              <div>
                <el-switch
                  v-model="voiceRoomDetail.open"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="開啟"
                  inactive-text="關閉"
                  @change="handleOpen"
                >
                </el-switch>
              </div>
            </div>
            <div class="item">
              <span class="label">管理員</span>
              <div class="value">
                <div
                  v-for="item of voiceRoomDetail.adminUsers"
                  :key="item.adminUsers"
                >
                  <span>{{ item.nickname }}</span
                  ><span>({{ item.uuid }})</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>暫無數據</div>
        </el-card>
        <el-card class="admin-user-box">
          <div slot="header" class="clearfix">
            <span>廳成員</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="addFixedUser()"
              >新增成員</el-button
            >
          </div>
          <el-table
            :max-height="$refs.main ? $refs.main.offsetHeight - 100 : 600"
            :data="fixedUsers"
            border
            style="width: 100%"
          >
            <el-table-column prop="nickname" label="暱稱" min-width="120">
            </el-table-column>
            <el-table-column prop="uuid" label="uuid" min-width="120">
            </el-table-column>
            <el-table-column prop="avatarUrl" label="頭像" min-width="120">
              <template slot-scope="scope">
                <el-image
                  style="width: 80px; height: 80px"
                  :src="scope.row.avatarUrl"
                  :preview-src-list="[scope.row.avatarUrl]"
                  fit="cover"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="120">
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small"
            >查看</el-button
          > -->
                <el-button
                  type="danger"
                  size="small"
                  @click="deleteFixedUser(scope.row, scope.$index)"
                  >刪除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </template>
    </div>

    <el-dialog
      title="添加成員"
      :visible.sync="dialogVisible"
      width="320px"
      append-to-body
    >
      <el-input
        v-model="fixedUserUuid"
        :placeholder="'請輸入用戶ID'"
        clearable
        @input="getUser()"
        style="margin-bottom:20px"
      />
      <div v-loading="getUserLoading">
        <div v-if="fixedUser && fixedUser.uuid">
          <el-image
            style="width: 100px; height: 100px;margin-bottom:10px "
            fit="cover"
            :src="fixedUser.avatarUrl"
          >
          </el-image>
          <div>{{ fixedUser.nickname }}</div>
        </div>
        <div v-else>未查找到用戶</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="!fixedUser.uuid" @click="submitAdd"
          >確 定</el-button
        >
      </span>
    </el-dialog>
    <edit-voice-room-vue
      :voiceRoomDetail="voiceRoomDetail"
      ref="editForm"
      @update-success="editVoiceRoomSuccess"
    ></edit-voice-room-vue>
  </div>
</template>
<script>
import EditVoiceRoomVue from './voice-room-form.vue';
// import { mapGetters } from 'vuex';
export default {
  name: 'UserList',
  components: {
    EditVoiceRoomVue
  },
  props: {
    isWhiteUser: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    voiceRoomDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // voiceRoomList: [],
      // roomUid: '',
      // fixedUsers: [],
      fixedUserUuid: '',
      fixedUser: {},
      dialogVisible: false,
      getUserLoading: false,
      tableLoading: false,
      addLoading: false
      // voiceRoomDetail: null
    };
  },
  computed: {
    // ...mapGetters(['userInfo', 'token']),
    // uuid() {
    //   return this.userInfo ? this.userInfo.uuid : '';
    // },
    tableHeight() {
      if (this.$refs.main && this.refs.header) {
        return (
          this.$refs.main.offsetHeight - this.$refs.header.offsetHeight - 10
        );
      } else {
        return 600;
      }
    },
    fixedUsers() {
      return this.voiceRoomDetail.fixedUsers || [];
    },
    roomUid() {
      return this.voiceRoomDetail.roomUid || '';
    }
  },
  methods: {
    deleteFixedUser(user, index) {
      const { uuid, nickname } = user;
      this.$confirm({
        content: `確定要將${nickname}從成員中刪除嗎`,
        title: '提示',
        showCancelButton: true,
        confirmButtonText: '確定',
        closeOnClickModal: false
      }).then(() => {
        this.$http
          .get('/voiceRoom/admin/unsetFixed', {
            roomUid: this.roomUid,
            uuid
          })
          .then(() => {
            this.fixedUsers.splice(index, 1);
            this.$message.success('刪除成功');
            // this.getVoiceRoom();
          });
      });
    },
    addFixedUser() {
      if (!this.roomUid) {
        return;
      }
      this.fixedUser = {};
      this.fixedUserUuid = '';
      this.dialogVisible = true;
    },
    submitAdd() {
      this.$http
        .get('/voiceRoom/admin/setFixed', {
          roomUid: this.roomUid,
          uuid: this.fixedUser.uuid
        })
        .then(() => {
          this.dialogVisible = false;
          this.$message.success('添加成功');
          this.$emit('add-admin-success');
        });
    },
    getUser() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getUserLoading = true;
        this.$http
          .get('/user/detail/info', { uuid: this.fixedUserUuid })
          .then(({ data }) => {
            this.fixedUser = data || {};
            this.getUserLoading = false;
          })
          .catch(() => {
            this.fixedUser = {};
            this.getUserLoading = false;
          });
      }, 1500);
    },
    editVoiceRoom() {
      if (!this.roomUid) {
        return;
      }
      this.$refs.editForm.open();
    },
    editVoiceRoomSuccess() {
      this.$emit('edit-voice-room-success');
    },
    handleOpen($event) {
      try {
        this.$http.post('/voiceRoom/admin/updateOpen', {
          open: $event,
          roomUid: this.roomUid
        });
      } catch (error) {
        this.voiceRoomDetail.open = !this.voiceRoomDetail.open;
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.admin-list {
  height: 100%;
}
.main {
  display: flex;
  height: 100%;
}
.detail-box {
  min-width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .clearfix {
    flex: none;
  }
  /deep/ .el-card__body {
    height: 1px;
    flex: auto;
    overflow: auto;
  }
  .item {
    display: flex;
    margin-bottom: 20px;
    .label {
      width: 100px;
      color: #99a9bf;
    }
    .value {
      max-width: 160px;
      line-height: 1.5;
    }
  }
}
.admin-user-box {
  flex: 1;
  margin-left: 40px;
}
</style>
